import React, { Component, ReactNode } from 'react'
import { Form, Dropdown as SDropdown, Input as SInput, Button as SButton, FormDropdownProps, DropdownItemProps, Grid, StrictGridColumnProps, FormInputProps, Modal } from 'semantic-ui-react'
import { FastField, Field, getIn } from 'formik'
import ErrorMessage from './ErrorMessage'
import { FormikComponentProps, getFieldError, setFieldValue } from './FormikHelpers'
import { collectFeatureOptions, getLocalizedLabel, getmeta, getRefTargets, Meta, valueInOptions, valueIsSimpleId, valueNotEmpty } from '../../common'
import { withTranslation, WithTranslation } from 'react-i18next'
import Input from './Input'
import Dropdown from './Dropdown'
import Button from './Button'
import SelectCunit from './SelectCunit'
import { AxiosInstance } from 'axios'

export const decodeName = (name) => {
    return(name.replace(/\+/g, ' '))
}

export const encodeName = (name) => {
    return(name.replace(/ /g, '+'))
}

export const extractName = (ref) => {
    const m = ref.match(/name="?([^\]]*)"?/)
    return m ? decodeName(m[1]) : null
}

export interface InputFeatureValueRefProps extends FormikComponentProps, WithTranslation {
  meta: Meta,
  http: AxiosInstance,
  cunitValues: any,
  inputProps?: FormInputProps|FormDropdownProps
  basePath?: string,
  name: string,
  feature: any,
  fmeta: any,
  noHighlighting?: boolean,
}

interface InputFeatuyreValueRefState {
  addCunit: boolean
}

class InputFeatureValueRef extends Component<InputFeatureValueRefProps, InputFeatuyreValueRefState> {

  state = {
      addCunit: false
  }

  render() {

    const {
        meta,
        cunitValues,
        feature,
        name,
        label,
        inputProps = {},
        fieldProps = {},
        errorComponent = ErrorMessage,
        fast,
        basePath,
        i18n,
        t,
        validate,
        fmeta,
        noHighlighting
    } = this.props

    const {onChange, ...safeInputProps} = inputProps
    const DesiredField = fast === true ? FastField : Field
    
    const composeNewType = (base: string, spec: string|null) => {
      if (spec!==null && spec!==undefined) {
        return([base, spec].join(':'))
      }
      return (base)
    }

    const defaultValidate = (s: string) => {
      if (!s || (String(s).startsWith(':')) || (String(s).endsWith(':'))) return t('Incomplete value') 
    }

    const shortDesc = false
    const valueType = fmeta.params.value_type
    const multi = valueType === 'multiref'
    const values = multi ? feature.value : [feature.value]

    let options = [] as DropdownItemProps[]

    if (fmeta.params.ref_targets.includes('cunit')) {
      return (
          <DesiredField name={name} validate={validate ? validate : defaultValidate}>
            {({field, form, formmeta}) => {
              return (
                <>
                <Modal size="large" open={!!this.state.addCunit} closeIcon={true} onClose={() => this.setState({addCunit: false})} centered={false}>
                    <Modal.Header>{t('Selection')} ({cunitValues.name})</Modal.Header>
                    <Modal.Content>
                        <SelectCunit {...this.props} cunitType={cunitValues._type} multi={multi} values={values}
                          update={(value) => setFieldValue(form, name, value, true)}
                          close={() => this.setState({addCunit: false})}/>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="blue" onClick={() => this.setState({addCunit: false})}>{t('Close')}</Button>
                    </Modal.Actions>
                </Modal>
                {values.map(v => (
                  <span className="unit_desc">
                    {extractName(v)}
                    { multi && values.length>1 ?
                      <Button icon="delete" type="button" size='mini' color='red'
                        className="checkbox-size"
                        onClick={() => {
                        setFieldValue(form, name, values.filter(sv => sv!==v), true)
                      }}/>
                    : null }
                  </span>
                ))}
                {!values.length || multi ? 
                  <Button type="button" color="blue" size="mini" icon="plus" title={t('Add')}
                          onClick={(e,d) => this.setState({addCunit: true})}/>
                : null}
                </>
              )
            }}
          </DesiredField>
      )
    } else {
      options = cunitValues ? getRefTargets(meta, cunitValues, {
                  slot: fmeta.params.ref_targets && fmeta.params.ref_targets.includes('slot'), 
                  filler: fmeta.params.ref_targets && fmeta.params.ref_targets.includes('filler')
              }, t, shortDesc) : []
      // add missing values (fallback for errors in data)
      values.forEach(v => {
          if (v !== null && v !== undefined && !options.map(o => o.value).includes(v)) options.push({key: v, value: v, text: t('[Invalid reference!]')})
      })

      if (multi) {
        if (options)
        {
            const multiProps = multi ? {multiple: true, selection: true} : {}
            return (
                <Dropdown name={name} inputProps={{...multiProps, ...safeInputProps} as FormDropdownProps}
                        validate={v => valueInOptions(v, options)} label={label}
                        noHighlighting={noHighlighting} options={options}/>
            )
        } else {
            return (
                <Input name={name} inputProps={safeInputProps}
                    label={label} noHighlighting={noHighlighting}/>
            )
        }
      } else {
        return(
          <DesiredField name={name} validate={validate ? validate : defaultValidate}>
            {({field, form, formmeta}) => {
              const error = getFieldError(field, form)
              const [base, ...specs] = field.value ? String(field.value).split(':') : []
              const spec = specs.length ? specs.join(':') : null

              if (options) {
                return(
                  <Grid>
                  <Grid.Row>
                  <Grid.Column width={14}>
                  <Form.Field  error={base===''} {...fieldProps}>
                  <SDropdown
                      id={`field_${name}`}
                      name={name}
                      options={options}
                      selectOnBlur={false}
                      selectOnNavigation={false}
                      selection
                      search
                      {...safeInputProps}
                      disabled={safeInputProps.disabled}
                      value={base}
                      onChange={(e, {name, value}) => {
                        const newValue = composeNewType(value as string, spec)
                        setFieldValue(form, name, newValue, true)
                        /*Promise.resolve().then(() => {
                          onChange && onChange(e, {name, newValue})
                        })*/
                      }}
                      onBlur={form.handleBlur}
                    />
                    { error && (
                      React.createElement(errorComponent, { message: getIn(form.errors, name) })
                    )}
                    </Form.Field>
                    </Grid.Column>
                    <Grid.Column width={2}>
                    { spec === null ? 
                    (
                      <SButton type="button" size="mini" icon="ellipsis horizontal" title={t('Add link specification')}
                              onClick={(e,d) => {setFieldValue(form, name, composeNewType(base, ''), true);e.preventDefault()}}/>
                    ) : (
                      <Form.Field error={spec===''} validate={valueNotEmpty} {...fieldProps}>
                      <SInput
                          id={`field_${name}_spec`}
                          name={name}
                          {...safeInputProps}
                          disabled={safeInputProps.disabled}
                          value={spec}
                          onChange={(e, {name, value}) => {
                            const newValue = composeNewType(base, value.trim())
                            setFieldValue(form, name, newValue, true)
                            /*Promise.resolve().then(() => {
                              onChange && onChange(e, {name, newValue})
                            })*/
                          }}
                          onBlur={form.handleBlur}
                        />
                        </Form.Field>
                    )}
                  </Grid.Column>
                  </Grid.Row>
                  </Grid>
                )
              } else {
                return (
                  <Input name={name} inputProps={inputProps as FormInputProps} validate={validate}/>
                )
              }
            }}
          </DesiredField>
        )
      }
    }
  }

}

export default withTranslation()(InputFeatureValueRef)